import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import oncommit from "../../assets/onconext.png";
import avatarVideo from "../../assets/avatares/mute-blue.webm";
import avatarVideoMp4 from "../../assets/avatares/mute-blue.mp4";
import manuelVideo from "../../assets/videos/video-sc4-ct2.webm";
import manuelVideoMp4 from "../../assets/videos/video-sc4-ct2.mp4";
import flechaAvanzar from "../../assets/right-arrow.svg";
import { modalPresentacionManuel } from "../../utils/logger";
import ScenarioBar from "../../components/ScenarioBar";
import avatarDummy from "../../assets/avatares/avatar-dummy-green.png";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario4Context2({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 1.0
	});

	const transcription = ""

	const handleContinue = () => {
		navigate(ROUTES.SCENARIO4_QUIZ5);
	};

	const abrirModal = () => {
		if (videoRef.current) {
			videoRef.current.pause();
		}
		modalPresentacionManuel(transcription, manuelVideo, manuelVideoMp4, handleContinue, flechaAvanzar, canPlayWithSound, 1.0, "blue", true);
	};

	const activeScenario = getScenarioNumByPath(location.pathname);

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-4 d-flex flex-column justify-content-end h-75 px-4">
						<video
							ref={videoRef}
							autoPlay
							playsInline
							preload="auto"
							muted
							loop
						>
							<source src={avatarVideoMp4}  type="video/mp4" />
							<source src={avatarVideo} type="video/webm" />
						</video>
					</div>

					{/* Columna derecha: espacio visual */}
					<div className="col-md-8 d-flex flex-column justify-content-center align-items-end bg-blur-blue h-100 px-5">
						<div className="recuadro-white recuadro-border-blue txtTexto1 mb-3 w-100">
							<h3 className="txtTitulos blue mb-4">
								Efectos adversos
							</h3>
							<div className="d-flex justify-content-center">
								<div className="button-escuchar-paciente button-escuchar-paciente-blue mt-4 mb-4"
									onClick={abrirModal}
								>
									Ver la exploración física
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ScenarioBar activeScenario={activeScenario} />
		</div>
	);
}

export default injectIntl(Scenario4Context2);
